export default {
  state: {
    isMenuOpen: false,
  },
  mutations: {
    SET_IS_HAM_MENU_OPEN(state, payload) {
      if (payload) {
        state.isMenuOpen = payload
      } else {
        state.isMenuOpen = !state.isMenuOpen
      }
    },
  },
  getters: {
    GET_IS_HAM_MENU_OPEN(state) {
      return state.isMenuOpen
    },
  },
}
